const useAcuratePercentage = () => {
    const getPercentages = (belowCount: number, atOrAboveCount: number) =>  {
        const total = belowCount + atOrAboveCount || 1;
        const rawBelow = (belowCount / total) * 100;
        const rawAtOrAbove = (atOrAboveCount / total) * 100;
      
        let belowPercent = Math.round(rawBelow);
        let atOrAbovePercent = Math.round(rawAtOrAbove);
      
        const sum = belowPercent + atOrAbovePercent;
        if (sum !== 100) {
          if (belowPercent > atOrAbovePercent) {
            belowPercent -= sum - 100;
          } else {
            atOrAbovePercent -= sum - 100;
          }
        }
      
        return { belowPercent, atOrAbovePercent };
      }
  
    return {
        getPercentages,
    };
  };
  
  export default useAcuratePercentage;